import { CONDOMINIUM_TYPES } from '../actions/types';

const initialState = {
    selectedCondominium: null,
    condominium: null,
    provider: null,
    makingRequest: false,
    id: null,
}

export default function condominiumReducer (state = initialState, action) {
    switch (action.type) {

        case CONDOMINIUM_TYPES.SELECT_CONDOMINIUM:
            return {
                selectedCondominium: action.payload
            };

        case CONDOMINIUM_TYPES.CONDOMINIUM_NAME:
            return {
                ...state,
                condominium: action.payload
            };
        case CONDOMINIUM_TYPES.CONDOMINIUM_ADDRESS:
            return {
                ...state,
                address: action.payload
            };
       
        case CONDOMINIUM_TYPES.CONDOMINIUM_ID:
            return {
                ...state,
                phone: action.payload
            };
        case CONDOMINIUM_TYPES.UNSELECT_CONDOMINIUM:
            return {
                selectedCondominium: null,
                condominium: null,
                address: null,
                id: null,
            };
        case CONDOMINIUM_TYPES.SELECT_PROVIDER:
            return {
                ...state,
                provider: action.payload
            };
        case CONDOMINIUM_TYPES.UNSELECT_PROVIDER:
            return {
                ...state,
                provider: null
            };
        case CONDOMINIUM_TYPES.MAKING_REQUEST:
            return {
                ...state,
                makingRequest: true
            };
        case CONDOMINIUM_TYPES.NOT_MAKING_REQUEST:
            return {
                ...state,
                makingRequest: false
            };
        default:
            return state;
    }
}